import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUpperArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M24.975 17.398c.067.109-.009.251-.133.251h-3.727a.16.16 0 0 0-.158.163v11.025A.16.16 0 0 1 20.8 29h-9.6a.16.16 0 0 1-.159-.163V17.812a.16.16 0 0 0-.158-.163H7.158c-.124 0-.2-.142-.133-.251l8.842-14.322c.062-.101.204-.101.266 0l8.842 14.322Z"
	})
});
export default SvgUpperArrow;
